<template>
  <div class="slide-menu">
    <!-- 漢堡按鈕 -->
    <div class="burger-button" @click="showMenu = !showMenu">
      <img src="~@/assets/images/menu.png" />
    </div>

    <!-- 側選單 -->
    <div class="menu" :class="{ show: showMenu }">
      <div class="menu-header">
        <!-- <img src="~@/assets/images/home-banner-1.jpg" /> -->
        <!-- <img src="~@/assets/images/menu-logo.svg" /> -->
        選單
      </div>

      <!-- 功能按鈕 -->
      <div
        v-for="(functionListItem, funcIndex) in functionList"
        :key="funcIndex"
      >
        <div class="group-button">
          <span>{{ functionListItem.name }}</span>
        </div>
        <div class="group-items">
          <div
            v-for="(subFunctionListItem,
            subFuncIndex) in functionListItem.subList"
            :key="subFuncIndex"
            @click="
              handleRoutePath(functionListItem.id, subFunctionListItem.subId)
            "
          >
            {{ subFunctionListItem.subName }}
          </div>
        </div>
      </div>

      <!-- 關閉按鈕 -->
      <div class="cross-button" @click="showMenu = false">
        <img src="~@/assets/images/close.svg" />
      </div>
    </div>

    <!-- 遮罩 -->
    <div
      class="mask"
      :class="{ show: showMenu }"
      @click="showMenu = false"
    ></div>
  </div>
</template>

<script>
import Vue from 'vue';
import store from 'Store/store';
import { BCollapse, VBToggle } from 'bootstrap-vue';
import FunctionList from 'Assets/mockData/FunctionList.json';

Vue.component('b-collapse', BCollapse);
Vue.directive('b-toggle', VBToggle);

export default {
  name: 'Sidemenu',
  data() {
    return {
      showMenu: false,
      activeFunction: '',
      functionList: FunctionList,
    };
  },
  computed: {
    slideMenuList() {
      return store.state.main.slideMenuList;
    },
    activeSubFunc() {
      let path = this.$route.path.split('/');
      return path[1];
    },
  },
  methods: {
    checkShowing(item) {
      if (item.subName === '線上點燈') {
        return store.state.main.onlineStatus.lightInfo.enable;
      } else if (item.subName === '平安宴') {
        return store.state.main.onlineStatus.reposeInfo.enable;
      }
      return true;
    },
    handleActiveGroup(newFuncId) {
      if (this.activeFunction !== newFuncId) {
        this.activeFunction = newFuncId;
      } else {
        // 再次點擊，收合function
        this.activeFunction = '';
      }
    },
    handleRoutePath(funcId, subFuncId) {
      let currentPage = this.$route.query.page;
      if (funcId === this.activeSubFunc && subFuncId === currentPage) {
        this.showMenu = false;
        return;
      }

      this.$router.push({ path: `/${funcId}?page=${subFuncId}` });
      this.showMenu = false;
    },
  },
};
</script>

<style scope>
/* 漢堡按鈕 */
.burger-button {
  position: fixed;
  top: 15px;
  left: 15px;
  z-index: 4;
  cursor: pointer;
}

.burger-button > img {
  width: 30px;
  height: 30px;
}

/* 側選單 */
.menu {
  width: 0px;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  overflow-x: hidden;
  background-color: #ffffff;
  transition: 0.5s;
}

.menu.show {
  width: 300px;
}

.menu-header {
  width: 100%;
  height: 118px;
  background: #ffffff;
  display: flex;
  /* justify-content: center; */
  font-weight: bold;
  font-size: 20px;
  line-height: 155px;
  text-align: left;
  margin-left: 64px;
}
.menu-header img {
  width: 100%;
  height: 100px;
  margin: auto 0;
}

.group-button {
  font-size: 12px;
  color: #ffffff;
  padding: 16px 16px 16px 20px;
  text-align: left;
  /* border-bottom: 1px solid #ffffff; */
  transition: 0.5s;
  cursor: pointer;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  white-space: nowrap;
  position: relative;
  background-color: #b18147;
  height: 36px;
}

.group-button > span {
  width: 93%;
  display: inline-block;
}

.group-button > img {
  /* adjust css for ie */
  position: absolute;
  top: 0px;
  right: 16px;
  width: 24px;
  height: 100%;
  transition: all 0.7s;
}

.angle-up {
  transform: rotate(-180deg);
}

.active-group {
  color: #ffffff;
  /* border-bottom: 4px solid #b18147; */
}

.group-items > div {
  font-size: 14px;
  color: #1b1b1b;
  padding: 16px 20px;
  text-align: left;
  background-color: #ffffff;
  border-bottom: 1px solid #d6d6d6;
  cursor: pointer;
  width: 100%;
  display: flex;
  white-space: nowrap;
  font-weight: bold;
}

.group-items > div:hover {
  background-color: rgba(89, 89, 89, 0.2);
}

/* 關閉按鈕 */
.cross-button {
  position: absolute;
  top: 62px;
  left: 20px;
  cursor: pointer;
}

.cross-button > img {
  width: 30px;
  height: 30px;
}

/* 遮罩 */
.mask {
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #000000;
  opacity: 0.4;
  z-index: 5;
}

.mask.show {
  display: block;
}

.hide-item {
  display: none;
}

@media (min-width: 768px) {
  .slide-menu {
    display: none;
  }
}
</style>
